<div>
  @switch (screen) {
    @case ('step1') {
      <div>
        <div class="as-cancel-dialog-header">
          <p
            class="as-font-20 as-font-w-700 as-font as-font-black-gray as-roboto-slab"
            >
            {{ 'TRACKING.selectMotive' | translate }}
          </p>
          <mat-icon
            svgIcon="ic-close-green"
            class="as-pointer"
            mat-dialog-close
          ></mat-icon>
        </div>
        <hr class="as-divider" />
        <form>
          @for (motive of motiveList; track motive) {
            <div>
              <div class="as-cancel-motive">
                <input
                  type="radio"
                  [(ngModel)]="motiveSelected"
                  name="motive"
                  id="{{ motive.motive_id }}"
                  [value]="motive.motive_id"
                  />
                <label class="as-cancel-label" for="{{ motive.motive_id }}">{{
                  motive.description
                }}</label>
              </div>
            </div>
          }
          <p class="as-font-14 as-font-w-700 as-font as-font-black-gray">
            {{ 'GENERAL.optionalComents' | translate }}
          </p>
          <div class="as-cancel-comments-container">
            <textarea
              class="as-cancel-comments as-open-sans"
              [(ngModel)]="comments"
              name="comments"
              placeholder="Agrega un comentario"
              rows="3"
              maxlength="150"
            ></textarea>
          </div>
        </form>
        <div class="as-button-container">
          <button
            class="as-cancel-button"
            mat-flat-button
            color="accent"
            type="button"
            [disabled]="!motiveSelected"
            (click)="nextStep()"
            >
            <mat-label class="as-font as-font-semibold as-font-white">
              {{ 'TRACKING.cancel' | translate }}
            </mat-label>
          </button>
        </div>
      </div>
    }
    @case ('step2') {
      <div>
        <div class="as-cancel-secondstep-container">
          <div class="as-cancel-dialog-header">
            <p
              class="as-font-20 as-font-w-700 as-font as-font-black-gray as-roboto-slab"
              >
              {{ 'CANCELLATIONS.sureCancel' | translate }}
            </p>
          </div>
          <div class="as-cancel-dialog-body">
            <p class="as-font-16 as-font-400 as-font as-font-black-gray">
              {{ 'CANCELLATIONS.confirmCancelWarn' | translate }}
            </p>
          </div>
          @if (!loading) {
            <div class="as-button-container">
              <button
                class="as-return-button"
                mat-flat-button
                type="button"
                [disabled]="loading"
                (click)="prevStep()"
                >
                <mat-label class="as-font as-font-semibold as-font-green">
                  {{ 'GENERAL.return' | translate }}
                </mat-label>
              </button>
              <button
                class="as-cancelorder-button"
                mat-flat-button
                type="button"
                [disabled]="loading"
                (click)="cancelOrder()"
                >
                <mat-label class="as-font as-font-semibold as-font-white">
                  {{ 'TRACKING.cancel' | translate }}
                </mat-label>
              </button>
            </div>
          } @else {
            <div
              class="spinner as-spinner-green-no-margin as-row as-justify-center as-spinner-container"
              >
              <mat-spinner [diameter]="32"></mat-spinner>
            </div>
          }
          <ng-template #spinner>
            <div
              class="spinner as-spinner-green-no-margin as-row as-justify-center as-spinner-container"
              >
              <mat-spinner [diameter]="32"></mat-spinner>
            </div>
          </ng-template>
        </div>
      </div>
    }
    @case ('cantCancel') {
      <div>
        <div class="as-cantcancel-dialog">
          <div class="as-cantcancel-content">
            <div class="as-button-close">
              <mat-icon
                svgIcon="ic-close-green"
                class="as-pointer"
                mat-dialog-close
              ></mat-icon>
            </div>
            <div class="as-cantcancel-body">
              <div class="as-cantcancel-icon-section">
                <mat-icon svgIcon="ic-alert-change-password"></mat-icon>
              </div>
              <div class="as-cantcancel-text-section">
                <p class="as-font-20 as-font-w-700 as-roboto-slab">
                  {{ 'CANCELLATIONS.sorryCantCancel' | translate }}
                </p>
                <p class="as-font-16 as-font-400 as-open-sans">
                  {{ 'CANCELLATIONS.cantCancelWarn' | translate }}
                </p>
              </div>
            </div>
            <div class="as-cantcancel-button-container">
              <button
                class="as-help-button"
                mat-flat-button
                color="accent"
                type="button"
                (click)="closeModal('support')"
                >
                <mat-label class="as-font as-font-semibold as-font-white">
                  {{ 'CANCELLATIONS.contactSupport' | translate }}
                </mat-label>
              </button>
              <div class="as-continue-btn">
                <button mat-flat-button type="button" mat-dialog-close>
                  <mat-label class="as-font as-font-semibold as-font-green">
                    {{ 'CANCELLATIONS.continueOrder' | translate }}
                  </mat-label>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
